import Util from '../util.jsx'
import currency from '../currency.jsx'

class BudgetCalculation {
  calculateTotalFromHoursAndRate (item) {
    item.bUseTotal = false
    item.total = currency.round(parseFloat(item.noHours) * parseFloat(item.pricePerHour))

    if (item.type === 'expense-activity') {
      this.calculateSellingPriceFromMarkup(item)
    }

    this.calculatePercentage(item)
  }

  calculateHoursAndRateFromTotal (item) {
    item.bUseTotal = true
    item.noHours = 0
    item.pricePerHour = 0

    if (item.type === 'expense-activity') {
      this.calculateSellingPriceFromMarkup(item)
    }

    this.calculatePercentage(item)
  }

  calculatePercentage (item) {
    item.percentage = 0

    if (item.spentAmount !== 0 && item.total !== 0) {
      item.percentage = Util.calculatePercentage(item.spentAmount, item.total)
    }
  }

  calculateSellingPriceFromMarkup (item) {
    const budgetTotal = parseFloat(item.total) || 0
    const markupPercentage = parseFloat(item.markupPercentage) || 0

    item.sellingPrice = budgetTotal

    if (markupPercentage) {
      item.sellingPrice = currency.round((budgetTotal * (1 + (markupPercentage / 100))))
    }
  }

  calculateMarkupFromSellingPrice (item) {
    const budgetTotal = parseFloat(item.total) || 0
    const sellingPrice = parseFloat(item.sellingPrice) || 0

    if (budgetTotal) {
      item.markupPercentage = currency.round(100 * ((sellingPrice / budgetTotal) - 1))
    }
  }

  calculateSpentAmountFromRate (item) {
    if (!item.bUseTotal) {
      item.spentAmount = item.timeSpent ? item.pricePerHour * (item.timeSpent / 60) : 0
      item.percentage = Util.calculatePercentage(item.spentAmount, item.total)
    }
  }
}

export default new BudgetCalculation()
